import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RemoveAttributeValueFilters,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { ProductListStateExtension } from "@tecumseh/Handlers/ProductListStateExtension";

type HandlerType = HandlerWithResult<ProductListStateExtension, ProductListStateExtension>;

export const RemoveAttributeValueFiltersExtension: HandlerType = props => {
    props.result.attributeValueIds = props.result.attributeValueIds?.filter(
        x => !props.parameter.attributeValueIds?.find(y => y === x),
    );
    if (!props.parameter.categoryId) {
        props.result.isInitialLoad = false;
    } else {
        delete props.result.isInitialLoad;
    }
    if (props.result.attributeValueIds?.length === 0) {
        props.result.attributeValueIds = undefined;
    }
};

replaceInChain(chain, RemoveAttributeValueFilters, RemoveAttributeValueFiltersExtension);
